/**
 * @generated SignedSource<<77f1e70ec27936e5cf3f69a6a6c7a721>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type latestDeployment_softwareReleasesLaunchCard_jiraVersion$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion">;
  readonly " $fragmentType": "latestDeployment_softwareReleasesLaunchCard_jiraVersion";
};
export type latestDeployment_softwareReleasesLaunchCard_jiraVersion$key = {
  readonly " $data"?: latestDeployment_softwareReleasesLaunchCard_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"latestDeployment_softwareReleasesLaunchCard_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "FragmentSpread",
      "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "9635192fd480eb66a7ef3d1c281498c0";

export default node;
